import { useRequiredContext } from "@redotech/react-util/context";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import ReceiptCheckIcon from "@redotech/redo-icons/receipt-check.svg";
import ReceiptCheckFilledIcon from "@redotech/redo-icons/receipt-check_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { memo } from "react";
import { LockableSecondaryNavItem } from "./lockable-secondary-nav-item";

export const CheckoutItems = memo(function CheckoutItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <LockableSecondaryNavItem
      buttonLocation={ScheduleDemoButtonLocation.NAV_CHECKOUTS}
      feature={ConversionFeature.CHECKOUTS}
      FilledIcon={ReceiptCheckFilledIcon}
      friendlyName="Checkouts"
      href={routes.getConversionSubRoute("checkouts")}
      id="checkouts"
      UnfilledIcon={ReceiptCheckIcon}
    />
  );
});
